module.exports = __webpack_public_path__ + "img/new-map.023ff567.png";